export default __webpack_public_path__ + "static/media/announcement.cef24cbb.svg";